import { FC } from "react";
import { useTranslation } from "react-i18next";
import { useRecoilValue, useSetRecoilState } from "recoil";

import { PIC } from "@ryde/assets";
import { MuiButton } from "@ryde/controls";

import {
  dashboardCardsAtom,
  dashboardEditorAtom,
} from "../dynamic-dashboard.atoms";
import { DASHBOARD_MAX_CARDS } from "../dynamic-dashboard.models";
import { DashboardViewHandlingPanel } from "./views";

/**
 * Right-side header cluster for the dashboard: Create View + Views controls and
 * the "New" button (opens the card editor). "New" is disabled at the card cap.
 */
export const DynamicDashboardHeaderActions: FC = () => {
  const { t } = useTranslation();
  const setEditor = useSetRecoilState(dashboardEditorAtom);
  const cards = useRecoilValue(dashboardCardsAtom);
  const atCardLimit = cards.length >= DASHBOARD_MAX_CARDS;

  return (
    <>
      <DashboardViewHandlingPanel />

      <MuiButton
        startIcon={<PIC.PlusSvg />}
        sx={{ flexShrink: 0 }}
        e2eData="dashboard-new-card"
        disabled={atCardLimit}
        onClick={() => setEditor({ isOpen: true, cardId: null })}
      >
        {t("dashboard.dynamic.newChart", { defaultValue: "New" })}
      </MuiButton>
    </>
  );
};
